import '../shared/logger';
import { initUtmTracking } from './utm/initUtmTracking';
export const PlayAppLoggerInitializer = () => {
  initUtmTracking();
  return null;
};